import { InjectionKey } from 'vue'

export type SigningChecklistAddProvidedData = {
    addFromTemplate: boolean
}
export const signingChecklistAddInjectionKey: InjectionKey<SigningChecklistAddProvidedData> = Symbol('SigningChecklistAddProvidedData')